import { render, staticRenderFns } from "./CountryName.vue?vue&type=template&id=a637c4f4&"
import script from "./CountryName.vue?vue&type=script&lang=ts&"
export * from "./CountryName.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports